const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'ui',
  tiles: {
    icon_attack: 0,
    icon_coin: 1,
    icon_defense: 2,
    icon_hp: 3,
    icon_key: 4,
    icon_supply: 5
  },
  uidata: {
    rects: [
      vec4(8/256,8/64,16/256,16/64),
      vec4(32/256,8/64,40/256,16/64),
      vec4(56/256,8/64,64/256,16/64),
      vec4(80/256,8/64,88/256,16/64),
      vec4(104/256,8/64,112/256,16/64),
      vec4(128/256,8/64,136/256,16/64)
    ]
  },
  layers: undefined,
  FRAME_ICON_ATTACK: 0,
  FRAME_ICON_COIN: 1,
  FRAME_ICON_DEFENSE: 2,
  FRAME_ICON_HP: 3,
  FRAME_ICON_KEY: 4,
  FRAME_ICON_SUPPLY: 5
};
spritesheetRegister(module.exports);
